import { NGXAjax } from '../../common/Services/AjaxService';
import { ApiUtils } from '../../common/api';
import PageCollection from './page-collection';
import PageModel from './page-model';

function fetchPages(experienceId) {
  return NGXAjax.get(`api/xp/page/campaign/${experienceId}.json`)
    .then(ApiUtils.validate, ApiUtils.validate)
    .then(ApiUtils.extract)
    .then(PageCollection.deserialize);
}

/**
 *
 * @param {string} templateId the page template id
 * @param {string} campaignId the experience we are adding the new page to
 * @returns {array[pages]} this returns a list of pages for the experience.
 * Note that it's important it returns the list as the page on it's own would be tricky to insert in the
 * correct place in the list with the minimal ordering information is has in each page record
 */
function createFromTemplate(templateId, campaignId) {
  return NGXAjax.post('api/xp/page/createFromTemplate.json', { templateId, campaignId })
    .then(ApiUtils.validate)
    .then(ApiUtils.extract)
    .then(PageCollection.deserialize)
    .catch((error) => error);
}

function savePages(pages) {
  return NGXAjax.post('/api/xp/page/update.json', PageCollection.serialize(pages), undefined, { postJSON: true })
    .then(ApiUtils.validate, ApiUtils.validate)
    .then(ApiUtils.extract)
    .then(PageCollection.deserialize);
}

function _updateSerializedPage(serializedPayload) {
  const { id, ...page } = serializedPayload;

  return NGXAjax.post(`/api/xp/page/update/${id}.json`, page, undefined, { postJSON: true })
    .then(ApiUtils.validate)
    .then(ApiUtils.extract1)
    .then(PageModel.deserialize)
    .catch((error) => error);
}

function updatePage(page) {
  return _updateSerializedPage(PageModel.serialize(page));
}

function deletePage(id) {
  return NGXAjax.post('/api/xp/page/delete.json', { id })
    .then(ApiUtils.validate, ApiUtils.validate)
    .then(ApiUtils.extract)
    .then(PageCollection.deserialize)
    .catch((error) => error);
}

function fetchEmptyPhases(experienceId) {
  return NGXAjax.get(`api/xp/page/phasesWithoutPages/${experienceId}.json`)
    .then(ApiUtils.validate, ApiUtils.validate)
    .then(ApiUtils.extract)
    .catch((error) => error);
}

// Reorder pages by passing in a comma separated list of the page states in the new order
function reorderStates(experienceId, order) {
  return NGXAjax.post('api/flow/reorderStates.json', { id: experienceId, order })
    .then(ApiUtils.validate)
    .then(ApiUtils.extract)
    .catch((error) => error);
}

export default {
  deletePage,
  fetchPages,
  createFromTemplate,
  savePages,
  updatePage,
  fetchEmptyPhases,
  reorderStates,
};
